module.exports = __webpack_public_path__ + "static/media/jota.5918f5b1.png";